"use client";

import { CcSeoProcess } from "@/components/services/seo/CcSeoProcess";
import type { SeoPageCopy } from "@/components/services/seo/seo-page-copy";
import { ECOM_PROCESS_ILLUSTRATIONS } from "@/components/services/web-design/ecommerce/ecom-process-illustrations";

/** Same four store-building steps as the e-commerce page, so the illustrations are shared. */
export function CcShopifyProcess({ copy }: { copy: SeoPageCopy["process"] }) {
  return (
    <div id="shopify-process">
      <CcSeoProcess copy={copy} illustrations={ECOM_PROCESS_ILLUSTRATIONS} />
    </div>
  );
}
